import { render, staticRenderFns } from "./ResetPasswordInstructions.vue?vue&type=template&id=02087fd2&scoped=true"
import script from "./ResetPasswordInstructions.vue?vue&type=script&lang=js"
export * from "./ResetPasswordInstructions.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordInstructions.vue?vue&type=style&index=0&id=02087fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02087fd2",
  null
  
)

export default component.exports